// extracted by mini-css-extract-plugin
module.exports = {"container":"PdfReader_container__1gvXm","reader":"PdfReader_reader__X0o7F","page":"PdfReader_page__2U6bO","nav":"PdfReader_nav__18ttW"};